/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllStagedEquipmentResponse } from '../../models/get-all-staged-equipment-response';

export interface AdminServiceGetAllStagedEquipment$Params {
}

export function adminServiceGetAllStagedEquipment(http: HttpClient, rootUrl: string, params?: AdminServiceGetAllStagedEquipment$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllStagedEquipmentResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetAllStagedEquipment.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllStagedEquipmentResponse>;
    })
  );
}

adminServiceGetAllStagedEquipment.PATH = '/api/v3/gateway/admin/stage/equipment';
